<ng-container *ngIf="isLoaded; else handleNoAttributionData">
  <ng-container *ngIf="isValidSignIn; else handleSignIn">
    <!-- Attribution section header -->
    <eds-section-header
      [title]="'products.attribution-title' | translate"
      [level]="6"
      caveatPlacement="Fund Attribution:FundAttribution"
      edsSpacing="md"
    ></eds-section-header>

    <!-- Section proximal top -->
    <eds-proximal placement="FundAttributionProximalTop"></eds-proximal>

    <!-- Timeperiod tabs -->
    <eds-tabs
      [followFocus]="true"
      [isNavigation]="false"
      [cacheActive]="true"
      [fullWidth]="true"
      dropdownTheme="handheld"
    >
      <!-- Quarterly -->
      <eds-tab
        tabId="attribution-tab-quarterly"
        [heading]="'products.attribution-tab-quarterly' | translate"
      >
        <ft-timeperiod-data
          [periodDates]="periodDates"
          [timePeriodData]="timePeriods.quarterly"
          [showCurrencyAttribution]="showCurrencyAttribution"
          [selectedAsOfDateStd]="selectedAsOfDateStd"
          [selectedGridDataType]="selectedGridDataType"
          [fundName]="fundName"
          [bmName]="bmName"
          [tabNumber]="0"
          (fetchAttributionData)="fetchAttributionData($event)"
          (triggerDownloadAction)="onDownloadButtonClicked($event)"
        ></ft-timeperiod-data>
      </eds-tab>

      <!-- 12-Month rolling -->
      <eds-tab
        tabId="attribution-tab-twelve-month-rolling"
        [heading]="'products.attribution-tab-twelve-month-rolling' | translate"
      >
        <ft-timeperiod-data
          [periodDates]="periodDates"
          [timePeriodData]="timePeriods.twelveMonthRolling"
          [showCurrencyAttribution]="showCurrencyAttribution"
          [selectedAsOfDateStd]="selectedAsOfDateStd"
          [selectedGridDataType]="selectedGridDataType"
          [fundName]="fundName"
          [bmName]="bmName"
          [tabNumber]="1"
          (fetchAttributionData)="fetchAttributionData($event)"
          (triggerDownloadAction)="onDownloadButtonClicked($event)"
        ></ft-timeperiod-data>
      </eds-tab>

      <!-- Year-to-date -->
      <eds-tab
        tabId="attribution-tab-ytd"
        [heading]="'products.attribution-tab-ytd' | translate"
      >
        <ft-timeperiod-data
          [periodDates]="periodDates"
          [timePeriodData]="timePeriods.ytd"
          [showCurrencyAttribution]="showCurrencyAttribution"
          [selectedAsOfDateStd]="selectedAsOfDateStd"
          [selectedGridDataType]="selectedGridDataType"
          [fundName]="fundName"
          [bmName]="bmName"
          [tabNumber]="2"
          (fetchAttributionData)="fetchAttributionData($event)"
          (triggerDownloadAction)="onDownloadButtonClicked($event)"
        ></ft-timeperiod-data>
      </eds-tab>

      <!-- Calendar year -->
      <eds-tab
        tabId="attribution-tab-calendar-year"
        [heading]="'products.attribution-tab-calendar-year' | translate"
      >
        <ft-timeperiod-data
          [periodDates]="periodDates"
          [calendarYears]="calendarYears"
          [timePeriodData]="timePeriods.calendarYear"
          [showCurrencyAttribution]="showCurrencyAttribution"
          [selectedAsOfDateStd]="selectedAsOfDateStd"
          [selectedGridDataType]="selectedGridDataType"
          [fundName]="fundName"
          [bmName]="bmName"
          [tabNumber]="3"
          (fetchAttributionData)="fetchAttributionData($event)"
          (triggerDownloadAction)="onDownloadButtonClicked($event)"
        ></ft-timeperiod-data>
      </eds-tab>
    </eds-tabs>

    <!-- Section proximal bottom -->
    <eds-proximal placement="FundAttributionProximalBottom"></eds-proximal>
  </ng-container>
</ng-container>

<!-- Legacy sign-in box -->
<ng-template #handleSignIn>
  <div edsGrid *ngIf="isValidSignIn === false; else handleLoading">
    <div class="container--wide" *ngIf="!isAuth0Login">
      <ft-sign-in
        [inputParameters]="{
          skin: 'Basic 2 Columns',
          legacy: false,
          signOut: false
        }"
      >
      </ft-sign-in>
    </div>
    <div class="container--wide" *ngIf="isAuth0Login">
      <eds-panel [hasBorders]="true" [hasPadding]="true" [hasShadows]="true">
        <div>
          <h3>{{ "signin.sign-in-attribution-title" | translate }}</h3>
          <p>
            {{ "signin.sign-in-attribution-introText" | translate }}
          </p>
        </div>
        <div>
          <a edsButton [attr.stopNavigation]="true" (click)="goToAuth0()">{{
            "signin.signIn" | translate
          }}</a>
        </div>
      </eds-panel>
    </div>
  </div>
</ng-template>

<!-- No Attribution data message -->
<ng-template #handleNoAttributionData>
  <span *ngIf="isLoaded === false; else handleLoading">{{
    "products.attribution-no-data-error" | translate
  }}</span>
</ng-template>

<!-- Attribution data loading message -->
<ng-template #handleLoading>
  <span>{{ "products.attribution-data-loading" | translate }}</span>
</ng-template>
